import React, { FC } from 'react'
import Favorites from 'svg/heart-icon.svg'
import SALink from 'components/SALink'
import styles from './FavoritesIcon.module.scss'
import { getUserID, isAuthenticated as isAuthenticatedSelector } from 'selectors/user/session'
import { useSelector } from 'react-redux'

const FavoritesIcon: FC = () => {
  const isAuthenticated = useSelector(isAuthenticatedSelector)
  const userId = useSelector(getUserID)

  if (!isAuthenticated) {
    return null
  }

  return (
    <SALink
      aria-label='View your favorites'
      data-type='favorites-icon'
      data-gtm-event='top-nav'
      href={`/account/favorite/${userId}`}
      rel='nofollow'
      title='View Favorites'
      className={styles.favoritesLink}
    >
      <Favorites />
    </SALink>
  )
}

export default FavoritesIcon
